import type { KcContext } from 'keycloakify/login/KcContext';

import type { KcContext_LoginUsername } from 'src/shared/utils/kc-context/kc-context.js';

import { useFieldMessage } from './use-field-message.js';
import { useTriedToLoginWithNonExistedEmail } from './use-tried-to-login-with-non-existed-email.js';

export const useRedirectToSignUp = (kcContext: KcContext.Login | KcContext_LoginUsername) => {
    const { url } = kcContext;
    const emailError = useFieldMessage(['email', 'username'], kcContext);
    const triedToLoginWithNonExistedEmail = useTriedToLoginWithNonExistedEmail();

    if (emailError) {
        triedToLoginWithNonExistedEmail.set(true);
        // eslint-disable-next-line react-hooks/immutability -- Navigates away during render on purpose; deferring to an effect would flash the login page first.
        window.location.href = url.registrationUrl;
    }
};
